






































import { Component, Vue } from 'vue-property-decorator'
import { layers, context } from '@/store/modules'
import DotsLoader from '@/components/DotsLoader.vue'
import ButtonSheet from '@/components/ButtonSheet.vue'
import LayerFilter, { FilterCriterias } from '@/components/LayerFilter.vue'
import ScrollList from '@/components/ScrollList.vue'
import LayerCard from '@/components/LayerCard.vue'
import LayerWrapper from '@/orrm/wrapper/layer'
import findIndex from 'lodash/findIndex'
import intersectionWith from 'lodash/intersectionWith'
import { Thematique } from '@/orrm/model/thematique'
import { Phenomene } from '@/orrm/model/phenomene'
import { Public } from '@/orrm/model/public'
import AddLayerFluxForm from '@/components/AddLayerFluxForm.vue'
import intersection from 'lodash/intersection'

function intersectionWithName (a: any, b: any): boolean {
  return a.name === b.name
}

@Component({
  components: { AddLayerFluxForm, LayerCard, ScrollList, LayerFilter, ButtonSheet, DotsLoader }
})
export default class LayersIndex extends Vue {
  addLayerFluxDialog = false
  layersToAdd: LayerWrapper[] = []
  filters: FilterCriterias = {
    label: '',
    thematics: [],
    phenomenes: [],
    profile: []
  }

  get filteredLayers (): LayerWrapper[] {
    return this.layers.filter((layer: LayerWrapper) => {
      if (!layer.model.title.toLowerCase().includes(this.filters.label.toLowerCase())) return false
      if (this.filters.phenomenes.length && intersectionWith(layer.model.getPhenomenes(), this.filters.phenomenes, intersectionWithName).length === 0) return false
      if (this.filters.thematics.length && intersectionWith(layer.model.getThematiques(), this.filters.thematics, intersectionWithName).length === 0) return false
      if (this.filters.profile && this.filters.profile.length && !intersection(layer.model.getPublics().map((p: Public) => p.machineName), this.filters.profile).length) return false
      return true
    })
  }

  get layers (): LayerWrapper[] {
    return layers.layers
  }

  get loading () {
    return layers.loading
  }

  get thematics (): Thematique[] {
    return this.layers.reduce((acc: Thematique[], layer: LayerWrapper) => [...acc, ...layer.model.getThematiques()], [])
  }

  get phenomenes (): Phenomene[] {
    return this.layers.reduce((acc: Phenomene[], layer: LayerWrapper) => [...acc, ...layer.model.getPhenomenes()], [])
  }

  layersComparator (a: LayerWrapper, b: LayerWrapper): boolean {
    return a.model.uuid === b.model.uuid
  }

  addCustomLayer (layer: LayerWrapper) {
    this.layers.push(layer)
    this.addLayerFluxDialog = false
  }

  isLayerActive (layer: LayerWrapper) {
    if (!context.activeContext) return false

    for (const layerIteration of context.activeContext.layers) {
      if (this.layersComparator(layerIteration, layer)) {
        return true
      }
    }
    return false
  }

  onLayerCheck (checked: boolean, layer: LayerWrapper) {
    if (checked) {
      this.addLayer(layer)
    } else {
      this.removeLayer(layer)
    }
  }

  addLayer (layer: LayerWrapper) {
    const index = this.layersToAdd.indexOf(layer)

    if (index === -1) {
      this.layersToAdd.push(layer)
    }
  }

  updateActiveLayers () {
    if (context.activeContext) {
      const layers = [...context.activeContext.layers, ...this.layersToAdd]

      for (const layer of layers) {
        if (layer.model.layerType === 'fake') continue // On ignore les "fake layers"
        const cb = (l: LayerWrapper) => l.model.uuid === layer.model.uuid
        const index = findIndex(context.activeContext.layers, cb)
        const toAddIndex = findIndex(this.layersToAdd, cb)

        if (~index && !~toAddIndex) {
          context.activeContext.layers.splice(index, 1)
        } else if (!~index && ~toAddIndex) {
          context.activeContext.layers.push(layer)
        }
      }
    }

    if (context.activeContext && context.activeContext.model.uuid) {
      this.$router.push({ name: 'LayersList' })
    } else {
      this.$router.back()
    }
  }

  removeLayer (layer: LayerWrapper) {
    const index = this.layersToAdd.indexOf(layer)

    if (index !== -1) {
      this.layersToAdd.splice(index, 1)
    }
  }

  async created () {
    if (!context.activeContext) {
      this.$router.push({ name: 'Home' })
    }

    await layers.fetchAllLayers()

    for (const layer of this.layers) {
      if (this.isLayerActive(layer)) {
        this.addLayer(layer)
      }
    }
  }
}
